import { VStack } from '@dotfile/frontend/shared/design-system';
import { ClientPortalCase_ContactCase } from '@dotfile/shared/data-access-client-portal';

import { CaseEntityCard } from './case-entity-card';

export type CaseEntityListProps = {
  cases: ClientPortalCase_ContactCase[];
};

export const CaseEntityList = ({ cases }: CaseEntityListProps) => {
  return (
    <VStack spacing="6">
      {cases.map((caseEntity) => {
        return <CaseEntityCard case={caseEntity} key={caseEntity.id} />;
      })}
    </VStack>
  );
};
